/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandPointClickBIcon24Solid = forwardRef('HandPointClickBIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11 1a6 6 0 0 0-6 6 1 1 0 0 0 2 0 4 4 0 0 1 8 0 1 1 0 1 0 2 0 6 6 0 0 0-6-6Z" }),
        React.createElement("path", { d: "M9 7v7.75l-2.442-1.07a1.931 1.931 0 0 0-2.09 3.184l4.813 4.468a2.5 2.5 0 0 0 1.7.668h4.648a2.5 2.5 0 0 0 2.431-1.917l1.317-5.487a2.5 2.5 0 0 0-2.009-3.047L13 10.8V7a2 2 0 0 0-4 0Z" })));
});
